<script>
    import R, {LOADER} from "../lib/requests";
    import {createEventDispatcher} from 'svelte/internal';
    import {setFocusTo} from "../lib/lib";
    import InputGroupColor from "../components/controls/InputGroupColor.svelte";
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";


    export let tag;
    export let objectType;

    let edit = false;
    let name = '';
    let color = '';

    const dispatch = createEventDispatcher();

    const onKeyDown = (event) => {
        if (event.key === "Enter") {
            onSave();
            return;
        }

        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            edit = false;
            dispatch("cancel");
        }
    }

    const onEdit = () => {
        name = tag.name;
        color = tag.color;
        edit = true;
        setFocusTo(`tag-${tag.id}`);
    }

    const onSave = () => {
        const onSuccess = result => {
            tag.id = result.id;
            tag.name = result.name;
            tag.color = result.color;
            edit = false;
            dispatch("change", tag);
        }

        const onFailure = err => {
        };

        name = name.trim();
        if (!name) {
            Notifier.showError("Εισάγετε ένα όνομα για την ετικέτα!");
            setFocusTo(`tag-${tag.id}`);
            return;
        }

        let data = {
            id: tag.id,
            name,
            color,
            object_type: objectType
        }

        R.handle(R.tag[tag.id > 0 ? 'edit' : 'create'], data, onSuccess, onFailure, LOADER.POPUP);
    }

    const onRemove = () => {
        Alert.confirm("Διαγραφή ετικέτας", `Να διαγραφεί οριστικά η ετικέτα "${tag.name}";`, deleteTag);
    }

    const deleteTag = () => {
        const onSuccess = result => {
            dispatch("delete", tag);
        }

        const onFailure = err => {
        };

        R.handle(R.tag.delete, tag.id, onSuccess, onFailure, LOADER.POPUP);
    }

    $: if (tag.id == 0) {
        onEdit();
    }
</script>

{#if edit}
    <div class="input-group edit-placeholder">
        <InputGroupColor bind:value="{ color }"/>
        <input type="text" class="form-control" id="tag-{tag.id}" bind:value="{ name }" on:keydown={onKeyDown}>
        <button class="btn btn-outline-secondary" type="button" on:click={onSave}>
            <AppIcon icon="check" strokeWidth="2"/>
        </button>
    </div>
{:else}
    <button class="btn tag" on:click={onEdit}>
        <ColoredNameControl name="{ tag.name }" color="{ tag.color }" colorName/>
        <span class="remove" on:click|preventDefault|stopPropagation={onRemove}><AppIcon icon="x"/></span>
    </button>
{/if}

<style>
    .edit-placeholder {
        margin: 1px 0;
    }

    .tag {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        border: 1px solid #e4eaee;
        border-radius: 4px;
        padding: 10px;
        margin: 1px 0;
    }

    .tag .remove {
        padding: 2px;
    }
</style>